const middleware = {}

middleware['captureUtmVariables'] = require('../../../src/middleware/captureUtmVariables.ts')
middleware['captureUtmVariables'] = middleware['captureUtmVariables'].default || middleware['captureUtmVariables']

middleware['checkTokenMigrationStatus'] = require('../../../src/middleware/checkTokenMigrationStatus.ts')
middleware['checkTokenMigrationStatus'] = middleware['checkTokenMigrationStatus'].default || middleware['checkTokenMigrationStatus']

middleware['dontShowGame'] = require('../../../src/middleware/dontShowGame.ts')
middleware['dontShowGame'] = middleware['dontShowGame'].default || middleware['dontShowGame']

middleware['globalRouteBackAfterLogin'] = require('../../../src/middleware/globalRouteBackAfterLogin.ts')
middleware['globalRouteBackAfterLogin'] = middleware['globalRouteBackAfterLogin'].default || middleware['globalRouteBackAfterLogin']

middleware['inventoryDisclaimer'] = require('../../../src/middleware/inventoryDisclaimer.ts')
middleware['inventoryDisclaimer'] = middleware['inventoryDisclaimer'].default || middleware['inventoryDisclaimer']

middleware['isValidItemCollection'] = require('../../../src/middleware/isValidItemCollection.ts')
middleware['isValidItemCollection'] = middleware['isValidItemCollection'].default || middleware['isValidItemCollection']

middleware['pathAliasRedirect'] = require('../../../src/middleware/pathAliasRedirect.ts')
middleware['pathAliasRedirect'] = middleware['pathAliasRedirect'].default || middleware['pathAliasRedirect']

middleware['redirectAfterLogin'] = require('../../../src/middleware/redirectAfterLogin.ts')
middleware['redirectAfterLogin'] = middleware['redirectAfterLogin'].default || middleware['redirectAfterLogin']

middleware['requireAuth'] = require('../../../src/middleware/requireAuth.ts')
middleware['requireAuth'] = middleware['requireAuth'].default || middleware['requireAuth']

middleware['requireUnauth'] = require('../../../src/middleware/requireUnauth.ts')
middleware['requireUnauth'] = middleware['requireUnauth'].default || middleware['requireUnauth']

middleware['requireUserItem'] = require('../../../src/middleware/requireUserItem.ts')
middleware['requireUserItem'] = middleware['requireUserItem'].default || middleware['requireUserItem']

middleware['requireWallet'] = require('../../../src/middleware/requireWallet.ts')
middleware['requireWallet'] = middleware['requireWallet'].default || middleware['requireWallet']

middleware['routeBackAfterLogin'] = require('../../../src/middleware/routeBackAfterLogin.ts')
middleware['routeBackAfterLogin'] = middleware['routeBackAfterLogin'].default || middleware['routeBackAfterLogin']

middleware['routeNameAuthActions'] = require('../../../src/middleware/routeNameAuthActions.ts')
middleware['routeNameAuthActions'] = middleware['routeNameAuthActions'].default || middleware['routeNameAuthActions']

middleware['routeNameToQueryParam'] = require('../../../src/middleware/routeNameToQueryParam.ts')
middleware['routeNameToQueryParam'] = middleware['routeNameToQueryParam'].default || middleware['routeNameToQueryParam']

middleware['sanityRedirects'] = require('../../../src/middleware/sanityRedirects.ts')
middleware['sanityRedirects'] = middleware['sanityRedirects'].default || middleware['sanityRedirects']

middleware['savePreviousRoute'] = require('../../../src/middleware/savePreviousRoute.ts')
middleware['savePreviousRoute'] = middleware['savePreviousRoute'].default || middleware['savePreviousRoute']

middleware['setDebugOverrides'] = require('../../../src/middleware/setDebugOverrides.ts')
middleware['setDebugOverrides'] = middleware['setDebugOverrides'].default || middleware['setDebugOverrides']

middleware['setTheme'] = require('../../../src/middleware/setTheme.ts')
middleware['setTheme'] = middleware['setTheme'].default || middleware['setTheme']

middleware['setUser'] = require('../../../src/middleware/setUser.ts')
middleware['setUser'] = middleware['setUser'].default || middleware['setUser']

middleware['trackLoginEvent'] = require('../../../src/middleware/trackLoginEvent.ts')
middleware['trackLoginEvent'] = middleware['trackLoginEvent'].default || middleware['trackLoginEvent']

middleware['translate'] = require('../../../src/middleware/translate.ts')
middleware['translate'] = middleware['translate'].default || middleware['translate']

middleware['verifyEmail'] = require('../../../src/middleware/verifyEmail.ts')
middleware['verifyEmail'] = middleware['verifyEmail'].default || middleware['verifyEmail']

middleware['verifyIp'] = require('../../../src/middleware/verifyIp.ts')
middleware['verifyIp'] = middleware['verifyIp'].default || middleware['verifyIp']

export default middleware
